module.exports = "https://static.wmbcdn.com/uniweb/images/fd574f0620bd644266cc89464b729c1c.jpg";